import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { validateOperatorTitleRequestSearch } from "@/lib/title-request-case-link";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/title-requests")({
  validateSearch: validateOperatorTitleRequestSearch,
  component: OperatorPortalWorkPage,
});
